module.exports = __webpack_public_path__ + "img/sentiment.a7d3e09c.png";